

import React, { useEffect } from 'react';
import Signup from './components/Signup';
import './App.css';
import { createBrowserRouter, RouterProvider} from "react-router-dom";
import HomePage from './components/HomePage';
import GuestAccess from './components/GuestAccess';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import UsersPage from './components/UsersPage';
import MessagesPage from './components/MessagesPage';
import UserDetailPage from './components/UserDetailPage';
import MessageDetailPage from './components/MessageDetailPage';
import ChatBot from './components/ChatBot';
import ChatHistoryPage from './components/ChatHistoryPage';
import { useSelector, useDispatch } from "react-redux";
import io from "socket.io-client";
import { setSocket } from './redux/socketSlice';
import { setOnlineUsers, setAdminIds , prependUser, setAuthUser } from './redux/userSlice';
import { BASE_URL } from './config';
import axios from 'axios';
import { 
  updateLastMessageContent,
  updateLastMessageTimestamp 
} from './redux/userSlice';


const router = createBrowserRouter([
 { path: "/", element: <HomePage /> },

  { path: "/signup", element: <Signup /> },
  { path: "/login", element: <Login /> },
  { path: "/guest", element: <GuestAccess /> },
  { path: "/admin-dashboard", element: <AdminDashboard /> },
  { path: "/admin-dashboard/users/:id", element: <UserDetailPage /> },
  { path: "/admin-dashboard/messages/:id", element: <MessageDetailPage /> },
   { path:"/chat", element:<ChatBot/>},
  {
    path:"/chat-history",
    element:<ChatHistoryPage />
  },
]);

function App() {
  const { authUser ,  otherUsers} = useSelector(store => store.user);
  const { socket } = useSelector(store => store.socket);
  const dispatch = useDispatch();


  useEffect(() => {
    let socketio;

    const setupSocket = () => {
      if (!socket && authUser) {
        socketio = io(`${BASE_URL}`, {
          query: {
            userId: authUser._id
          },
          reconnection: true,
          reconnectionAttempts: Infinity,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          timeout: 20000,
          autoConnect: true
        });

        socketio.on('connect', () => {
          console.log("Connected to socket:", socketio.id);
          dispatch(setSocket(socketio));
        });


              const handleNewMessage = async (message) => {
          const { senderId , createdAt} = message;
            const serverTimestamp = new Date(createdAt).toISOString();


          try {
            // Check if user exists in current list
            const userExists = otherUsers.some(u => u._id === senderId);
              let userData;
            
            if (!userExists) {
              // Fetch user details
              const { data } = await axios.get(`${BASE_URL}/api/v1/user/${senderId}`);
              userData = data;

              dispatch(prependUser(data));
            }

            // Update last message info
            dispatch(updateLastMessageContent({
              userId: senderId,
              content: message.message
            }));
            
            dispatch(updateLastMessageTimestamp({
              userId: senderId,
              // timestamp: new Date().toISOString()
               timestamp: serverTimestamp
            }));
               // If new user, force re-sort
        // if (!userExists && userData) {
        //     dispatch(updateLastMessageTimestamp({
        //         userId: senderId,
        //         timestamp: new Date().toISOString()
        //     }));
        //             }

          } catch (error) {
            console.error("Error handling new message:", error);
          }
        };

        socketio.on('newMessage', handleNewMessage);


        socketio.on('getOnlineUsers', (onlineUsers) => {
          dispatch(setOnlineUsers(onlineUsers));
        });

        socketio.on('disconnect', (reason) => {
          console.log("Disconnected:", reason);
          if (reason === 'io server disconnect') {
            // The disconnection was initiated by the server, need to reconnect manually
            socketio.connect();
          }
        });

        socketio.on('connect_error', (error) => {
          console.log("Connection error:", error);
          setTimeout(() => {
            socketio.connect();
          }, 1000);
        });
      }
    };

    setupSocket();

    return () => {
      if (socketio) {
        socketio.off('connect');
        socketio.off('disconnect');
           socketio.off('newMessage');
        socketio.off('getOnlineUsers');
        socketio.off('connect_error');
        socketio.disconnect();
        console.log("Socket disconnected on cleanup");
        dispatch(setSocket(null));
      }
    };
  }, [authUser, dispatch, otherUsers]);

 

  return (
    <div className="h-screen flex items-center justify-center">
      <RouterProvider router={router} />
    </div>
  );
}

export default App; 